export const decodeBase64Image = (base64Str) => {
    var matches = base64Str.match(/^data:([A-Za-z-+/]+);base64,(.+)$/)
    var image = {}
    if (!matches || matches.length !== 3) {
      throw new Error('Invalid base64 string')
    }
    image.mimetype = matches[1]
    image.type = matches[1].replace('image/', '')
    image.data = new Buffer.from(matches[2], 'base64')
  
    return image
  }
  
  export const getTimeRemaining = (e) => {
    const total = Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / 1000 * 60 * 60) % 24);
    return {
        total, hours, minutes, seconds
    };
  }
  
  export const secondsToTime = (secs) =>{
      secs = Math.round(secs);
      const hours = Math.floor(secs / (60 * 60));
  
      const divisor_for_minutes = secs % (60 * 60);
      const minutes = Math.floor(divisor_for_minutes / 60);
  
      const divisor_for_seconds = divisor_for_minutes % 60;
      const seconds = Math.ceil(divisor_for_seconds);
      
      return `${hours < 10 ? `0${hours}` : hours}:${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
  
  }
  
  export const addAnswerProperty = (answers = [], currentPage = 0) =>{
    const newAnswers = answers.map( (answer, index) => {
      if(index !== currentPage - 1){
        switch (answer.type) {
          case 'multiple_choice': 
          case 'image_choice_multiple':
          case 'image_answer':
            if(!answer.answers) answer.answers = []
            break
          case 'ranking':
            if(!answer.answersR) answer.answersR = []
            break
          default:
            if(!answer.answer) answer.answer = null
            break
        }
      }
        return answer
    })
  
    return newAnswers
  }
  
  export const verifyRequiredQuestion = (question, onOpenModal, setMultipleModal) =>{
    if (!question.required) return true
  
    switch (question.type) {
      case 'link_question':
      case 'video_question':
        if((!question.subtype)){
          return onOpenModal()
        }else if(question.subtype === 'videoQuestionText' && !question.answer){
          return onOpenModal()
        }else if(question.subtype !== 'videoQuestionText' && !question.file){
          return  onOpenModal()
        }
      break;
      case 'image_choice_multiple':
      case 'multiple_choice':	
        if (question.answers && question.answers.length === 0) {
          return onOpenModal()
        }
        if(question.answers && question.answers.length < question.minimumOptions){
          return setMultipleModal(true)
        }
        if(question.answers && question.answers.length > question.maximumOptions){
          return setMultipleModal(true)
        }
        if(question.answers && !question.next && question.answers.length === 0){
          return onOpenModal()
        }
      break;	
  
      case 'ranking':
        if(!question.answersR){
          return onOpenModal()
        }
      break;	
  
      case 'image_answer':
                  if(!question.answers){
                      return onOpenModal()
                  }
              break;
  
        case 'video':
                  if (!question.dialTesting) {
                      return onOpenModal()
                  }
              break;
      case 'link_content':
      case 'text_content':
      case 'image_content':
      break;
  
      case 'category':
        let countOptions = 0;
        try {
            if ((question.answers).length > 0) {
                (question.answers).forEach(function (option, key) {
                    countOptions += (option.options).length;
                })
                if (countOptions !== (question.options).length) return onOpenModal()
            } else {
                return onOpenModal()
            }
        } catch (e) {
            return onOpenModal()
        }
  
      break;
  
      default:
        if(!question.answer){
          return onOpenModal()
        }
        break;	
    }
  
    return true
  }
  
  export const setSkips = (skips, answers) =>{
    if (skips) {
      skips.forEach(item => {
          const start = item[0], jumps = item[1]
          for (let i = start; i <= jumps; i++) {
            switch (answers[i].type) {
              case 'link_question':
              case 'video_question':
                  if (answers[i].subtype === 'videoQuestionText') {
                      answers[i].answer = null
                  }else{
                      answers[i].file = null
                  }
                  break;
                  case 'image_choice_multiple':
                  case 'multiple_choice':
                  case 'image_answer':
                      answers[i].answers = []
                  break;
                  case 'ranking':
                      answers[i].answerR = []
                  break;
                  case 'video':
                      answers[i].dialTesting = []
                  break;
                default:
                      answers[i].answer = null
                  break;
            }
          }
      })
  }
  return answers
  }
  
  export const setScrollBar = (arg)=>{
      let body = document.getElementsByTagName("body");
      let html = document.getElementsByTagName("html");
  
      body[0].style.overflow = arg;
      html[0].style.overflow = arg;
  }
  